export default __webpack_public_path__ + "static/media/ic-edit.af6701ab.svg";